import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { detectLang } from "@/data/i18n";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLangState] = useState(detectLang());

  const setLang = (l) => {
    localStorage.setItem("pulsar_lang", l);
    setLangState(l);
  };

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.me();
      setUser(data.user);
      setSubscription(data.subscription);
    } catch (e) {
      setUser(null);
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) localStorage.setItem("pulsar_ref", ref);
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.logout(); } catch (e) {}
    setUser(null);
    setSubscription(null);
  };

  return (
    <AuthContext.Provider value={{ user, subscription, loading, lang, setLang, refresh, logout, setUser, setSubscription }}>
      {children}
    </AuthContext.Provider>
  );
}
